import { useNavigate } from 'react-router-dom';
import { clearLocalSession } from '@Auth/clearLocalSession';
import { LoadingSpinner } from '@Auth/components/LoadingSpinner';
import { authProvider } from '@helpers/auth/authProvider';
import { useEffectOnce } from '@src/hooks';
import Nav from '@src/routes';

export const CognitoLogout = () => {
  const navigate = useNavigate();

  const signOut = async () => {
    try {
      clearLocalSession();
      await authProvider.logout();
    } catch {
      // Provider sign-out failure must not block local logout — state is already cleared
    } finally {
      navigate(Nav.Login);
    }
  };

  useEffectOnce(() => {
    signOut();
  });

  return <LoadingSpinner />;
};
